import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api-base.service';

export type TermAcceptanceStatus = 'ACCEPTED' | 'DECLINED';

/**
 * Espelha ILocationTermsState do backend
 * (src/modules/location-terms/location-terms.service.ts).
 */
export interface ILocationTermsState {
    /** Já considera status E versão do texto. */
    accepted: boolean;
    status: TermAcceptanceStatus | null;
    version: string | null;
    respondedAt: string | null;
    currentVersion: string;
}

/**
 * Aceite do termo de uso de localização.
 *
 * Endpoints sem barra inicial: o ApiService monta `${baseUrl}/${endpoint}`.
 */
@Injectable({ providedIn: 'root' })
export class LocationTermsService {
    private readonly apiService = inject(ApiService);

    buscarEstado(): Observable<ILocationTermsState> {
        return this.apiService.get<ILocationTermsState>('location-terms/me');
    }

    aceitar(): Observable<ILocationTermsState> {
        return this.apiService.post<ILocationTermsState>('location-terms/accept', {});
    }

    recusar(): Observable<ILocationTermsState> {
        return this.apiService.post<ILocationTermsState>('location-terms/decline', {});
    }
}
